export const GET_NOTIFICATIONS_LIST = 'GET_NOTIFICATIONS_LIST';
export const GET_NOTIFICATIONS_LIST_SUCCESS = 'GET_NOTIFICATIONS_LIST_SUCCESS';
